type DashboardIconProps = {
  className?: string;
  fill?: string;
};

export const DashboardIcon = ({
  className,
  fill = "#fff",
}: DashboardIconProps): React.ReactElement => (
  <svg
    fill={fill}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g
      id="Group_6543"
      data-name="Group 6543"
      transform="translate(10239 22938)"
    >
      <g
        id="Rectangle_1989"
        data-name="Rectangle 1989"
        transform="translate(-10239 -22938)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="10" height="10" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="9" height="9" rx="1.5" fill="none" />
      </g>
      <g
        id="Rectangle_1991"
        data-name="Rectangle 1991"
        transform="translate(-10239 -22926)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="10" height="10" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="9" height="9" rx="1.5" fill="none" />
      </g>
      <g
        id="Rectangle_1990"
        data-name="Rectangle 1990"
        transform="translate(-10227 -22938)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="10" height="10" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="9" height="9" rx="1.5" fill="none" />
      </g>
      <g
        id="Rectangle_1992"
        data-name="Rectangle 1992"
        transform="translate(-10227 -22926)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      >
        <rect width="10" height="10" rx="2" stroke="none" />
        <rect x="0.5" y="0.5" width="9" height="9" rx="1.5" fill="none" />
      </g>
    </g>
  </svg>
);
